import React from 'react'
//import resturant from './component/basics/resturant'
// eslint-disable-next-line no-unused-vars
import Temp from './component/weather/temp'

//import Resturant from './component/basics/Resturant'
const App = () => {
  return (
    <>
      <Temp/>
    </>  
  )
}

export default App